module.exports = { 
      attributes: {"title":"Shogi startet 2020 mit Tesuji's","date":"2020-01-10T00:00:00.000Z","author":"Richi","categories":["news"],"tags":["news"],"language":"de","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Auch in diesem Jahr betreiben wir Shogi aktiv weiter.\nDafür hat sich unser Spieler Fumihiro ins Zeug gelegt und einige Tesuji's aus dem Buch\n\"Habu no Housoku 1 Fu KinGin no Tesuji\" vom Autor Habu Yoshiharu herausgesucht.\nTesuji's bedeutet so viel wie das Maximum aus einer aktuellen Position herausholen.")]),_vm._v(" "),_c('image-reel',[_vm._v("\nErklärung|/praesentation/20200110/2020-01-10.jpg\n")]),_vm._v(" "),_c('p',[_vm._v("Insgesamt hat Fumihiro uns 6 Tesuji's vorgestellt.\nNach einem lockeren Einstieg waren die nächsten 4 schnell gelöst.\nNur beim Letzten gab es dann fast so viele Antworten wie Zuschauer.")]),_vm._v(" "),_c('p',[_vm._v("Viele Dank an Fumihiro, der sich die Mühe gemacht hat.")])],1) };
            this.$options.staticRenderFns = [];
          }
        }
      },
     }